import React from "react";
import PortraitDefault from "./components/PortraitDefault";
import { useAuthContext } from "./context/auth";
import Start from "./components/Program/Start";
import WarmUp from "./components/Program/WarmUp";
import PartInfo from "./components/Program/PartInfo";
import CoolDown from "./components/Program/CoolDown";
import Part from "./components/Program/Part";
import MainExerInfo from "./components/Program/MainExerInfo";
import MainExer from "./components/Program/MainExer";
import { ClubDayBadgesDetailData } from "./Api";
import ClubDay from "./components/ClubDay/ClubDay";

function PortraitScreen({
  clubDayChunks,
}: {
  clubDayChunks: ClubDayBadgesDetailData["classAchievements"][];
}) {
  const { step, basicProgram } = useAuthContext();

  const getScreen = () => {
    const samePageFirst = [
      <PortraitDefault key={"portrait-default"} />,
      <Start key={"start"} />,
      <WarmUp key={"warm-up"} />,
    ];
    const samePageLast = [
      <CoolDown key={"cool-down"} />,
      clubDayChunks.length > 0 ? (
        <ClubDay key={`club-day`} data={clubDayChunks} />
      ) : (
        <PortraitDefault key={"club-day-empty"} />
      ),
      <PortraitDefault key={"portrait-default"} />,
    ];
    const circuitPages = [
      ...samePageFirst,
      <PartInfo key={"part-info"} isPart1 />,
      <Part key={"part1"} isPart1 />,
      <PartInfo key={"part-info"} isPart1={false} />,
      <Part key={"part2"} isPart1={false} />,
      ...samePageLast,
    ];
    const basicPages = [
      ...samePageFirst,
      <MainExerInfo key={"main-exer-info"} />,
      <MainExer key={"main-exer"} />,
      ...samePageLast,
    ];

    return basicProgram?.programType === "BASIC"
      ? basicPages[step]
      : circuitPages[step];
  };
  return <>{getScreen()}</>;
}

export default PortraitScreen;
